var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg52(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2677)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16015 5.2149L0.0390583 24.3555C-0.0390667 24.4922 -4.16627e-06 24.668 0.117183 24.7852L24.7461 48.379C24.8828 48.5157 25.1172 48.5157 25.2734 48.379L49.8828 24.8047C50 24.6876 50.0391 24.5118 49.9609 24.3751L40.8398 5.23443C40.7812 5.09772 40.6445 5.01959 40.5078 5.01959H9.49218C9.35546 5.00006 9.21875 5.09772 9.16015 5.2149Z",
    fill: "#50AF95"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1641 26.3477C27.9883 26.3672 27.0703 26.4062 25.0391 26.4062C23.418 26.4062 22.2656 26.3672 21.8555 26.3477C15.5859 26.0742 10.918 24.9805 10.918 23.6719C10.918 22.3633 15.5859 21.2695 21.8555 20.9961V25.2539C22.2656 25.293 23.4375 25.3516 25.0586 25.3516C27.0117 25.3516 27.9688 25.2734 28.1445 25.2539V20.9961C34.3945 21.2695 39.0625 22.3633 39.0625 23.6719C39.0625 24.9805 34.4141 26.0547 28.1641 26.3477ZM28.1641 20.5664V16.7383H36.8945V10.9375H13.1445V16.7578H21.8555V20.5664C14.7656 20.8984 9.43359 22.3047 9.43359 23.9844C9.43359 25.6641 14.7656 27.0703 21.8555 27.4023V39.6094H28.1641V27.4023C35.2344 27.0703 40.5469 25.6836 40.5469 23.9844C40.5469 22.2852 35.2344 20.8789 28.1641 20.5664Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg52);
export default __webpack_public_path__ + "static/media/52.3b2ea9d4917a2a0de3911801ba324998.svg";
export { ForwardRef as ReactComponent };